import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=2075427e&"
import script from "./Filtro.vue?vue&type=script&lang=js&"
export * from "./Filtro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports